<template>
  <div class="mod-config">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('payment.title') }}</span>
        <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="margin-top: 10px;">
          <el-tab-pane label="预约服务" name="appointment"></el-tab-pane>
          <el-tab-pane label="产品销售" name="product"></el-tab-pane>
        </el-tabs>
      </div>
      
      <!-- 预约服务标签页内容 -->
      <div v-if="activeTab === 'appointment'">
        <!-- 客户信息部分 -->
        <el-form :model="form" ref="form" label-width="100px" :rules="rules">
          <el-divider content-position="left">{{ $t('payment.customerInfo') }}</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('payment.customerType')" prop="customerType">
              <el-radio-group v-model="form.customerType" @change="customerTypeChange">
                <el-radio :label="1">{{ $t('payment.casualCustomer') }}</el-radio>
                <el-radio :label="2">{{ $t('payment.member') }}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 散客信息 -->
        <div v-if="form.customerType === 1">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="$t('payment.name')" prop="name">
                <el-input v-model="form.name" :placeholder="$t('payment.inputCasualName')"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('payment.phone')" prop="phone">
                <el-input v-model="form.phone" :placeholder="$t('payment.inputCasualPhone')"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item>
                <el-button type="primary" @click="createMember">{{ $t('payment.createMemberAccount') }}</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        
        <!-- 会员信息 -->
        <div v-if="form.customerType === 2">
          <el-row :gutter="20">
            <el-col :span="18">
              <el-form-item label="会员搜索" prop="memberId">
                <el-input 
                  v-model="searchKey" 
                  placeholder="请输入会员账号/姓名/手机号"
                  @keyup.enter.native="searchMembers">
                  <el-button slot="append" icon="el-icon-search" @click="searchMembers"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <!-- 会员列表 -->
          <el-table
            v-if="members.length > 0"
            :data="members"
            border
            style="width: 100%; margin-bottom: 20px"
            @row-click="selectMember">
            <el-table-column prop="zhanghao" label="账号" width="120"></el-table-column>
            <el-table-column prop="xingming" label="姓名" width="120"></el-table-column>
            <el-table-column prop="shouji" label="手机号" width="150"></el-table-column>
            <el-table-column prop="yue" label="账户余额"></el-table-column>
            <el-table-column prop="viplevel" label="会员等级"></el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click.stop="selectMember(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
          
          <!-- 已选会员信息 -->
          <div v-if="selectedMember" class="selected-member">
            <el-alert
              title="已选会员"
              type="success"
              :closable="false">
              <template slot="title">
                已选会员：{{selectedMember.xingming}} ({{selectedMember.zhanghao}}) - 余额：¥{{selectedMember.yue}}
              </template>
            </el-alert>
          </div>
        </div>
        
        <!-- 服务信息部分 -->
        <el-divider content-position="left">{{ $t('payment.serviceInfo') }}</el-divider>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('payment.fitnessProject')" prop="projectId">
              <el-select 
                v-model="form.projectId" 
                filterable 
                :placeholder="$t('payment.selectProject')"
                @change="projectChange">
                <el-option
                  v-for="item in projects"
                  :key="item.id"
                  :label="item.xiangmumingcheng"
                  :value="item.id">
                </el-option>
                <el-option key="other" :label="$t('payment.otherProject')" value="other"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="form.projectId === 'other'">
            <el-form-item :label="$t('payment.projectName')" prop="customProjectName">
              <el-input v-model="form.customProjectName" :placeholder="$t('payment.inputCustomProjectName')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('payment.selectCoach')" prop="coachId">
              <el-select 
                v-model="form.coachId" 
                filterable 
                :placeholder="$t('payment.selectCoach')">
                <el-option
                  v-for="item in coaches"
                  :key="item.id"
                  :label="item.jiaolianxingming"
                  :value="item.id">
                </el-option>
                <el-option key="other" :label="$t('payment.noCoach')" value="other"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('payment.serviceDuration')" prop="duration">
              <el-input-number 
                v-model="form.duration" 
                :min="1" 
                :step="15"
                controls-position="right"
                @change="updateAmount"
                :placeholder="$t('payment.serviceDurationPlaceholder')">
              </el-input-number>
              <span class="unit">{{ $t('payment.minutes') }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('payment.serviceAmount')" prop="amount">
              <el-input-number 
                v-model="form.amount" 
                :min="0" 
                :precision="2"
                :step="10"
                controls-position="right"
                :placeholder="$t('payment.serviceAmountPlaceholder')">
              </el-input-number>
              <span class="unit">{{ $t('payment.yuan') }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('payment.startTime')" prop="startTime">
              <el-date-picker
                v-model="form.startTime"
                type="datetime"
                :placeholder="$t('payment.selectStartTime')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                @change="updateEndTime">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('payment.endTime')" prop="endTime">
              <el-date-picker
                v-model="form.endTime"
                type="datetime"
                :placeholder="$t('payment.selectEndTime')"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item :label="$t('payment.remark')" prop="remark">
              <el-input 
                type="textarea" 
                v-model="form.remark" 
                :placeholder="$t('payment.inputRemark')"
                :rows="3">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 支付方式选择 -->
        <el-divider content-position="left">{{ $t('payment.paymentInfo') }}</el-divider>
        <payment-methods 
          v-model="form.paymentMethod" 
          :isMember="form.customerType === 2 && selectedMember"
          @change="paymentMethodChange">
        </payment-methods>
        
        <!-- 外设连接 -->
        <el-form-item :label="$t('payment.printSettings')">
          <el-switch
            v-model="printSettings.autoPrint"
            :active-text="$t('payment.autoPrintReceipt')"
            :inactive-text="$t('payment.manualPrintReceipt')">
          </el-switch>
          <el-select 
            v-if="printSettings.autoPrint" 
            v-model="printSettings.printerName" 
            placeholder="选择打印机" 
            size="small"
            style="margin-left: 20px;">
            <el-option
              v-for="printer in printers"
              :key="printer.name"
              :label="printer.name"
              :value="printer.name">
            </el-option>
          </el-select>
        </el-form-item>
        
        <!-- 提交部分 -->
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交付款</el-button>
          <el-button @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
      </div>
      
      <!-- 产品销售标签页内容 -->
      <div v-if="activeTab === 'product'">
        <sale-order-form @sale-success="handleSaleSuccess"></sale-order-form>
      </div>
    </el-card>
    
    <!-- 创建会员对话框 -->
    <el-dialog title="创建会员账号" :visible.sync="createMemberDialogVisible" width="40%">
      <el-form :model="memberForm" :rules="memberRules" ref="memberForm" label-width="100px">
        <el-form-item label="账号" prop="zhanghao">
          <el-input v-model="memberForm.zhanghao" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="mima">
          <el-input v-model="memberForm.mima" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="xingming">
          <el-input v-model="memberForm.xingming" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="shouji">
          <el-input v-model="memberForm.shouji" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="xingbie">
          <el-radio-group v-model="memberForm.xingbie">
            <el-radio label="男">男</el-radio>
            <el-radio label="女">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="createMemberDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitCreateMember">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PaymentMethods from '@/components/common/PaymentMethods'
import printService from '@/utils/printService'
import SaleOrderForm from '@/views/modules/sale/sale-order-form'

export default {
  components: {
    PaymentMethods,
    SaleOrderForm
  },
  data() {
    return {
      activeTab: 'appointment', // 默认显示预约服务
      form: {
        customerType: 1, // 1: 散客 2: 会员
        name: '',
        phone: '',
        memberId: null,
        projectId: null,
        customProjectName: '',
        coachId: null,
        duration: 60,
        amount: 0,
        remark: '',
        paymentMethod: 1, // 默认现金支付
        startTime: null, // 添加开始时间
        endTime: null    // 添加结束时间
      },
      rules: {
        customerType: [{ required: true, message: '请选择客户类型', trigger: 'change' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        memberId: [{ required: true, message: '请选择会员', trigger: 'change' }],
        projectId: [{ required: true, message: '请选择健身项目', trigger: 'change' }],
        customProjectName: [{ required: true, message: '请输入自定义项目名称', trigger: 'blur' }],
        duration: [{ required: true, message: '请输入服务时长', trigger: 'blur' }],
        amount: [{ required: true, message: '请输入服务金额', trigger: 'blur' }]
      },
      searchKey: '',
      members: [],
      selectedMember: null,
      projects: [],
      coaches: [],
      createMemberDialogVisible: false,
      memberForm: {
        zhanghao: '',
        mima: '',
        xingming: '',
        shouji: '',
        xingbie: '男'
      },
      memberRules: {
        zhanghao: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        mima: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        xingming: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        shouji: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        xingbie: [{ required: true, message: '请选择性别', trigger: 'change' }]
      },
      // 打印设置
      printSettings: {
        autoPrint: true,
        printerName: ''
      },
      // 可用打印机列表
      printers: [
        { name: 'HP LaserJet (默认)' },
        { name: '收据打印机' },
        { name: 'Epson TM-T88V' }
      ],
      // 支付成功后的数据
      paymentResult: null
    };
  },
  created() {
    this.getProjects();
    this.getCoaches();
  },
  methods: {
    // 根据客户类型变更表单验证规则
    customerTypeChange(val) {
      if (val === 1) {
        this.$refs.form.clearValidate('memberId');
      } else {
        this.$refs.form.clearValidate(['name', 'phone']);
      }
    },
    
    // 搜索会员
    searchMembers() {
      if (!this.searchKey) {
        this.$message.warning('请输入搜索关键词');
        return;
      }
      
      this.$http({
        url: '/yonghu/search',
        method: 'get',
        params: {
          keyword: this.searchKey
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.members = data.data || [];
          if (this.members.length === 0) {
            this.$message.info('未找到相关会员信息');
          }
        } else {
          this.$message.error('搜索会员失败');
        }
      });
    },
    
    // 选择会员
    selectMember(row) {
      this.selectedMember = row;
      this.form.memberId = row.id;
      this.form.name = row.xingming;
      this.form.phone = row.shouji;
    },
    
    // 获取健身项目列表
    getProjects() {
      this.$http({
        url: '/jianshenxiangmu/list',
        method: 'get',
        params: {
          page: 1,
          limit: 100
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.projects = data.data.list || [];
        }
      });
    },
    
    // 获取教练列表
    getCoaches() {
      this.$http({
        url: '/jiaolian/list',
        method: 'get',
        params: {
          page: 1,
          limit: 100
        }
      }).then(({data}) => {
        if (data && data.code === 0) {
          this.coaches = data.data.list || [];
        }
      });
    },
    
    // 项目改变时更新金额
    projectChange(projectId) {
      if (projectId !== 'other') {
        const selectedProject = this.projects.find(p => p.id === projectId);
        if (selectedProject && selectedProject.jiage) {
          this.form.amount = parseFloat(selectedProject.jiage);
        }
      }
    },
    
    // 更新结束时间
    updateEndTime() {
      if (this.form.startTime && this.form.duration) {
        const startTime = new Date(this.form.startTime);
        const endTime = new Date(startTime.getTime() + this.form.duration * 60000);
        // 格式化为yyyy-MM-dd HH:mm:ss格式
        this.form.endTime = this.formatDateTime(endTime);
      }
    },
    
    // 格式化日期时间
    formatDateTime(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const seconds = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 更新金额并计算时间
    updateAmount(duration) {
      if (this.form.projectId && this.form.projectId !== 'other') {
        const selectedProject = this.projects.find(p => p.id === this.form.projectId);
        if (selectedProject && selectedProject.jiage && selectedProject.durationMinutes) {
          // 根据项目默认时长和金额，按比例计算不同时长的金额
          const basePrice = parseFloat(selectedProject.jiage);
          const baseDuration = selectedProject.durationMinutes || 60;
          this.form.amount = (basePrice * duration / baseDuration).toFixed(2);
          
          // 如果已经设置了开始时间，更新结束时间
          if (this.form.startTime) {
            this.updateEndTime();
          }
        }
      }
    },
    
    // 打开创建会员对话框
    createMember() {
      this.memberForm.xingming = this.form.name;
      this.memberForm.shouji = this.form.phone;
      this.createMemberDialogVisible = true;
    },
    
    // 提交创建会员表单
    submitCreateMember() {
      this.$refs.memberForm.validate(valid => {
        if (valid) {
          this.$http({
            url: '/yonghu/register',
            method: 'post',
            data: this.memberForm
          }).then(({data}) => {
            if (data && data.code === 0) {
              this.$message.success('会员创建成功');
              this.createMemberDialogVisible = false;
              // 将创建的会员信息设置为已选会员
              this.searchKey = this.memberForm.zhanghao;
              this.searchMembers();
            } else {
              this.$message.error(data.msg || '会员创建失败');
            }
          });
        } else {
          return false;
        }
      });
    },
    
    // 支付方式变更处理
    paymentMethodChange(method) {
      // 如果选择会员余额，检查余额是否足够
      if (method === 2 && this.selectedMember) {
        if (parseFloat(this.selectedMember.yue) < parseFloat(this.form.amount)) {
          this.$message.warning('会员余额不足，请选择其他支付方式或先充值');
          this.form.paymentMethod = 1; // 重置为现金支付
        }
      }
    },
    
    // 提交付款表单
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 检查会员余额支付
          if (this.form.paymentMethod === 2 && this.form.customerType === 2) {
            if (parseFloat(this.selectedMember.yue) < parseFloat(this.form.amount)) {
              this.$message.warning('会员余额不足，请选择其他支付方式或先充值');
              return;
            }
          }
          
          // 构建提交数据
          const submitData = {
            customerType: this.form.customerType,
            projectId: this.form.projectId === 'other' ? null : this.form.projectId,
            customProjectName: this.form.projectId === 'other' ? this.form.customProjectName : null,
            coachId: this.form.coachId === 'other' ? null : this.form.coachId,
            duration: this.form.duration,
            amount: this.form.amount,
            remark: this.form.remark,
            paymentMethod: this.form.paymentMethod,
            startTime: this.form.startTime,
            endTime: this.form.endTime
          };
          
          // 根据客户类型添加不同参数
          if (this.form.customerType === 1) {
            // 散客
            submitData.customerName = this.form.name;
            submitData.customerPhone = this.form.phone;
          } else {
            // 会员
            submitData.memberId = this.form.memberId;
          }
          
          this.$http({
            url: '/paymentrecord/processpayment',
            method: 'post',
            data: submitData
          }).then(({data}) => {
            if (data && data.code === 0) {
              // 支付成功，保存返回的数据用于打印
              this.paymentResult = data.data;
              
              // 显示成功消息
              this.$message.success('付款处理成功');
              
              // 是否自动打印
              if (this.printSettings.autoPrint) {
                this.printReceipt();
              }
              
              // 显示收据操作对话框
              this.$confirm('是否需要发送电子收据?', '付款成功', {
                confirmButtonText: '发送邮件收据',
                cancelButtonText: '关闭',
                distinguishCancelAndClose: true,
                type: 'success'
              }).then(() => {
                // 发送邮件收据
                this.sendReceiptByEmail();
              }).catch(action => {
                if (action === 'cancel') {
                  // 用户点击关闭，重置表单
                  this.resetForm(formName);
                }
              });
            } else {
              this.$message.error(data.msg || '付款处理失败');
            }
          }).catch(error => {
            console.error('付款处理出错:', error);
            this.$message.error('付款处理出错，请检查网络连接或联系管理员');
          });
        } else {
          this.$message.warning('请完善表单信息');
          return false;
        }
      });
    },
    
    // 打印收据
    printReceipt() {
      if (!this.paymentResult) return;
      
      try {
        // 格式化打印数据
        const printData = {
          ...this.paymentResult,
          customerName: this.form.customerType === 1 ? this.form.name : this.selectedMember?.xingming,
          customerPhone: this.form.customerType === 1 ? this.form.phone : this.selectedMember?.shouji,
          zhanghao: this.form.customerType === 2 ? this.selectedMember?.zhanghao : '',
          projectName: this.getProjectName(),
          coachName: this.getCoachName(),
          operatorName: this.$store.getters.user.username || '管理员'
        };
        
        // 调用打印服务
        printService.printReceipt(printData, 'payment');
      } catch (error) {
        console.error('打印失败:', error);
        this.$message.error('打印收据失败: ' + error.message);
      }
    },
    
    // 发送邮件收据
    sendReceiptByEmail() {
      if (!this.paymentResult) return;
      
      // 准备邮件地址和数据
      let email = '';
      if (this.form.customerType === 2 && this.selectedMember?.zhanghao) {
        // 这里假设使用会员账号作为邮箱前缀
        email = `${this.selectedMember.zhanghao}@example.com`;
      }
      
      // 显示邮件对话框
      this.$prompt('请输入收件人邮箱', '发送收据', {
        confirmButtonText: '发送',
        cancelButtonText: '取消',
        inputValue: email,
        inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
        inputErrorMessage: '邮箱格式不正确'
      }).then(({ value }) => {
        // 准备打印数据
        const printData = {
          ...this.paymentResult,
          customerName: this.form.customerType === 1 ? this.form.name : this.selectedMember?.xingming,
          customerPhone: this.form.customerType === 1 ? this.form.phone : this.selectedMember?.shouji,
          zhanghao: this.form.customerType === 2 ? this.selectedMember?.zhanghao : '',
          projectName: this.getProjectName(),
          coachName: this.getCoachName(),
          operatorName: this.$store.getters.user.username || '管理员'
        };
        
        // 调用服务发送邮件
        printService.sendReceiptByEmail(printData, 'payment', value)
          .then(response => {
            if (response.code === 0) {
              this.$message.success('收据已发送至邮箱: ' + value);
              this.resetForm('form');
            } else {
              this.$message.error('发送邮件失败: ' + response.msg);
            }
          })
          .catch(error => {
            this.$message.error('发送邮件失败: ' + error.message);
          });
      }).catch(() => {
        // 用户取消，重置表单
        this.resetForm('form');
      });
    },
    
    // 获取项目名称
    getProjectName() {
      if (this.form.projectId === 'other') {
        return this.form.customProjectName;
      } else if (this.form.projectId) {
        const project = this.projects.find(p => p.id === this.form.projectId);
        return project ? project.xiangmumingcheng : '未知项目';
      }
      return '未知项目';
    },
    
    // 获取教练名称
    getCoachName() {
      if (this.form.coachId === 'other') {
        return '无教练';
      } else if (this.form.coachId) {
        const coach = this.coaches.find(c => c.id === this.form.coachId);
        return coach ? coach.jiaolianxingming : '未知教练';
      }
      return '未知教练';
    },
    
    // 重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.selectedMember = null;
      this.members = [];
      this.searchKey = '';
      this.paymentResult = null;
    },
    
    // 标签页切换
    handleTabClick(tab) {
      this.activeTab = tab.name;
    },
    
    // 销售成功处理
    handleSaleSuccess(saleOrder) {
      this.$message.success('产品销售成功！');
      // 可以在这里添加其他处理逻辑，比如打印小票等
    }
  }
};
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.selected-member {
  margin: 10px 0 20px;
}
.unit {
  margin-left: 5px;
}
</style> 